import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-enterprise-service-management',
  imports: [RouterModule, FeatureHero],
  templateUrl: './enterprise-service-management.html',
  styleUrl: './enterprise-service-management.scss',
})
export class EnterpriseServiceManagement {

}
